<ng-container *ngFor="let entity of entities">
  <span *ngIf="entity.text">{{ entity.text }}</span>
  <span *ngIf="entity.screenName" class="highlight">@{{ entity.screenName }}</span>
  <span *ngIf="entity.hashtag" class="highlight">#{{ entity.hashtag }}</span>
  <a *ngIf="entity.url" [href]="entity.url" (click)="onLinkClicked($event)" target="_blank">{{ entity.url }}</a>
</ng-container>
